<div *ngIf="params.data && !params.data.editable">
    {{params.data.targetdescription}}
</div>
<div *ngIf="params.data && params.data.editable">
    <textarea type="text" [(ngModel)]="params.data.targetdescription" style="width:100%;"
    placeholder="Place your text here" rows="5"></textarea>
</div>